import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './SecondaryEngipi.css';
import bgImg from '../assets/img/photoENGPI1.jpg';
import logoImg from '../components/images/logo.png';
import wayimg from '../assets/img/road_removed_bg.png';
// import Footer from '../components/Footer'; // Removed as it might be handled by MainLayout, checking AppRoutes

export default function SecondaryEngipi() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0); // يأخذ المستخدم لأعلى الصفحة عند الدخول
  }, []);

  return (
    <>
      <div id="first-section" className="secondary-engipi">
        <img src={bgImg} alt="Background" className="background-img" />

        <div className="content">
          <img src={logoImg} alt="Logo" className="top-logo" />
          <h2 className="thanwiy">{t('Home.Secondary.Thanwiy')}</h2>
          <div className="engpi-logo">
            <h2>ENG Pİ</h2>
            <div className="slogan">
              <span>{t('Home.Secondary.Slogan')}</span>
            </div>
          </div>
        </div>
      </div>

    <section className="new-section">
  <div className="top-row">
      <div className="title-pair">

    <div className="thanwiy2">{t('Home.Secondary.Thanwiy')}</div>
    <div className="engpi-logo2">ENG Pİ</div>
      </div>
    <div className="slogan2">{t('Home.Secondary.WhatIsProject')}</div>
  </div>

  <p className="description">
    {t('Home.Secondary.Description', { returnObjects: true })
      .split('{{highlight}}')
      .map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index === 0 && (
            <span className="colored">
              {t('Home.Secondary.DescriptionHighlight')}
            </span>
          )}
        </React.Fragment>
      ))}
  </p>
</section>

      <section className="second-section">
        <div
          className="projegoal"
          style={{
            textAlign: i18n.language === 'ar' ? 'right' : 'left',
            direction: i18n.language === 'ar' ? 'rtl' : 'ltr'
          }}
        >
          {t('Home.Secondary.ProjectGoals')}
        </div>
        <img src={wayimg} alt="way" className="wayphoto" />
        <div className="section-text">
          <ul>
            <li>{t('Home.Secondary.Goal1')}</li>
            <li>{t('Home.Secondary.Goal2')}</li>
            <li>{t('Home.Secondary.Goal3')}</li>
            <li>{t('Home.Secondary.Goal4')}</li>
            <li>{t('Home.Secondary.Goal5')}</li>
          </ul>
        </div>
      </section>

      {/* <Footer /> */}
      {/* Footer is likely included in MainLayout. If so, removing this prevents double footer. 
          Checking AppRoutes.js previously, SecondaryEngipi is inside MainLayout. 
          MainLayout usually has the Footer. Leaving checking for verification. */
      }
    </>
  );
}
